import BaseAvatar from '@kk/ui/components/BaseAvatar';
import Dropdown from '@kk/ui/components/Dropdown';
import Icon from '@kk/ui/components/Icon';
import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { UseExternalUserInfoResponse } from '#/api/hooks/useUserInfo';
import { logout } from '#/auth';
import { generateUrl } from '#/routes/generateUrl';

interface AccountMenuProps {
  user: UseExternalUserInfoResponse;
  inRouter: boolean;
  stateClasses: string;
}

export function AccountMenu({
  user,
  inRouter,
  stateClasses,
}: AccountMenuProps): React.ReactNode {
  const { t } = useTranslation();
  const { name, email } = user;

  return (
    <Dropdown
      className="min-w-50 max-w-62 p-2"
      alignment="start"
      header={
        <header className="border-b border-neutral-10 flex flex-col items-center justify-center space-y-2 px-4 py-2 pb-4 mb-2">
          <BaseAvatar fullName={name} isCurrentUser />
          <div className="flex flex-col items-center justify-center">
            <span className="typ-ui-sm text-neutral-200">{name}</span>
            <span className="typ-ui-sm hyphens-auto wrap-break-word text-center text-neutral-100">
              {email && email.length > 20 ? (
                <span className="flex flex-col">
                  <span>{email.split('@')[0]}</span>
                  <span>{`@${email.split('@')[1]}`}</span>
                </span>
              ) : (
                email
              )}
            </span>
          </div>
        </header>
      }
      button={{
        theme: 'primary',
        className: cn(
          'bg-blue-110 p-4 kunde:border-0 aria-expanded:kunde:bg-blue-60 transition-colors max-md:hidden',
          stateClasses,
        ),
        children: (
          <span className="flex items-center gap-2">
            <span className="typ-button-xs">{name}</span>
            <BaseAvatar size="small" fullName={name} />
          </span>
        ),
      }}
      options={[
        {
          children: (
            <button
              className="flex w-full items-center justify-between text-inherit"
              onClick={logout}
            >
              <span>{t('burgerMenu.logout')}</span>
              <Icon type="exit" />
            </button>
          ),
        },
        {
          children: inRouter ? (
            <Link className="flex justify-between" to={generateUrl('/profil')}>
              <span>{t('menu.profile')}</span>
              <Icon type="chevron-right" size="small" />
            </Link>
          ) : null,
        },
      ]}
    />
  );
}
